import { Component, OnInit } from '@angular/core';
import { FlexModule } from '@angular/flex-layout/flex';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-image-modal',
    templateUrl: './image-modal.component.html',
    styleUrls: ['./image-modal.component.scss'],
    standalone: true,
    imports: [FlexModule]
})
export class ImageModalComponent implements OnInit {
 imgSrc;
    constructor(public bsModalRef: BsModalRef,) { }

    ngOnInit(){}

    hide() {
        this.bsModalRef.hide();
    }


}
